import { createBrowserRouter, createHashRouter, Navigate, type RouteObject } from 'react-router-dom'
import { LocaleLayout } from './components/layout/LocaleLayout'
import { DatesStep } from './features/dates/DatesStep'
import { RateStep } from './features/rate/RateStep'
import { InfoStep } from './features/info/InfoStep'
import { PaymentStep } from './features/payment/PaymentStep'
import { SummaryStep } from './features/summary/SummaryStep'
import { AuthScreen } from './features/account/AuthScreen'
import { MyBookings } from './features/account/MyBookings'
import { ProfilePage } from './features/account/ProfilePage'
import { HomeScreen } from './features/home/HomeScreen'
import { FaqPage } from './features/info/FaqPage'
import { ContactsPage } from './features/info/ContactsPage'
import { isNativePlatform } from './lib/platform'

const routes: RouteObject[] = [
  { path: '/', element: <Navigate to="/it" replace /> },
  {
    path: '/:locale',
    element: <LocaleLayout />,
    children: [
      // home/landing is now the main page; the booking funnel starts at /book
      { index: true, element: <HomeScreen /> },
      { path: 'book', element: <DatesStep /> },
      // /home kept as an alias → main page
      { path: 'home', element: <Navigate to=".." replace relative="path" /> },
      { path: 'rate', element: <RateStep /> },
      // services merged into the rate step — redirect any old deep links
      { path: 'services', element: <Navigate to="../rate" replace relative="path" /> },
      { path: 'info', element: <InfoStep /> },
      { path: 'payment', element: <PaymentStep /> },
      { path: 'summary', element: <SummaryStep /> },
      // member account
      { path: 'login', element: <AuthScreen /> },
      { path: 'bookings', element: <MyBookings /> },
      { path: 'profile', element: <ProfilePage /> },
      // content pages (mirroring the real site)
      { path: 'faq', element: <FaqPage /> },
      { path: 'contacts', element: <ContactsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/it" replace /> },
]

// HashRouter in a Capacitor/native webview (no server rewrites); BrowserRouter on web.
export const router = isNativePlatform() ? createHashRouter(routes) : createBrowserRouter(routes)
